import React, { Component } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "./helpers/alertTemplate/alert-template";

// Material helpers
import { ThemeProvider } from "@material-ui/styles";

// Theme
import theme from "./theme";

// Providers
import { AuthProvider } from "./providers/AuthProvider";

// Routes
import Routes from "./Routes";

//Styles
import "@progress/kendo-theme-material/dist/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";
import "./theme/css/reset.css";
import "./theme/css/style-dashboard.css";
import "./theme/css/style-dashboard-v3.css";
//import './theme/css/style-onboarding.css'
import "antd/dist/antd.css";
import "./assets/custom.css";
import "./theme/css/style-telemetry.css";

import HUBContext from "./services/HUBContext";
import { getTempFilter } from "./common/utils";

// Google Tag Manager
import { gtmInit } from "./helpers/gtm";
import { Userpilot } from "userpilot";
import { isArray } from "lodash";

// Application Insights
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./AppInsights";
import { isProd } from "./utils/EnvironmentUtils";
import { HubContextService } from "./services/HubContextService";

// Browser history
const browserHistory = createBrowserHistory();

// Alerts options
const alertOptions = {
  timeout: 5000,
  position: positions.BOTTOM_RIGHT,
  containerStyle: { zIndex: 9999 },
};

gtmInit();

const USER_PILOT_ID = isProd() ? "NX-59gq9u3" : "STG-NX-59gq9u3";

Userpilot.initialize(USER_PILOT_ID);

export default class App extends Component {
  hubContextService = new HubContextService();

  state = {
    expiredSession: this.hubContextService.expiredSession,
  };

  onSessionExpired = () => {
    this.hubContextService.setExpiredSession(true);
    this.setState({ expiredSession: this.hubContextService.expiredSession });
  };

  onFocus = () => {
    //Check if session is expired
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      const extractedExpiration = access_token.split(".")[1];
      const expiration = JSON.parse(atob(extractedExpiration)).exp * 1000;
      const now = Date.now();
      if (now >= expiration) {
        this.onSessionExpired();
      }
    }
  };

  componentDidMount() {
    if (!!localStorage.getItem("filterCatalogs")) {
      try {
        const filterCatalogs = JSON.parse(
          localStorage.getItem("filterCatalogs"),
        );
        this.hubContextService.setFilterCatalogs(filterCatalogs);
      } catch (e) {}
    }

    const widgetGroups = getTempFilter("context-widget-groups");
    if (!!widgetGroups && isArray(widgetGroups))
      this.hubContextService.widgetGroups = widgetGroups;

    window.addEventListener("sessionExpired", this.onSessionExpired);
    window.addEventListener("focus", this.onFocus);
  }

  render() {
    return (
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <AlertProvider template={AlertTemplate} {...alertOptions}>
            <HUBContext.Provider value={this.hubContextService}>
              <AppInsightsContext.Provider value={reactPlugin}>
                <Router history={browserHistory}>
                  <Routes
                    expiredSession={this.hubContextService.expiredSession}
                  />
                </Router>
              </AppInsightsContext.Provider>
            </HUBContext.Provider>
          </AlertProvider>
        </ThemeProvider>
      </AuthProvider>
    );
  }
}
